import request from '../utils/request';
export function fetchClinicContacts(filters) {
    const params = new URLSearchParams();
    const clinic = filters?.clinic;
    const role = filters?.role;
    const search = filters?.search?.trim();
    if (clinic) {
        params.append('clinic', clinic);
    }
    if (role) {
        params.append('role', role);
    }
    if (search) {
        params.append('search', search);
    }
    const queryString = params.toString();
    const url = queryString
        ? `/api/v1/admin/clinic-contacts/?${queryString}`
        : '/api/v1/admin/clinic-contacts/';
    return request()
        .get(url)
        .send();
}
export function deleteClinicContact(id) {
    return request()
        .delete(`/api/v1/admin/clinic-contacts/${id}/`)
        .send();
}
export function updateClinicContact(id, payload) {
    return request()
        .patch(`/api/v1/admin/clinic-contacts/${id}/`)
        .send(payload);
}
export function createClinicContact(payload) {
    return request()
        .post('/api/v1/admin/clinic-contacts/')
        .send(payload);
}
